import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom'

const ErrorPage = () => {
    const location = useLocation();
    return (
        <Routes>
            <Route path='*' element={<NoContentPage location={location}/>}/>
        </Routes>
    )
}

const NoContentPage = ({ location }) => (
    <div style={{color: 'red'}}>
        <h3>Please login to see the <code>{location.pathname}</code> page if you have access.</h3>
        <h4>Otherwise go to <a href="https://aqcast.aer.com/">AQcast Home</a> for more information.</h4>
    </div>
)


export default ErrorPage;
